const INVOKE_FUNCTIONS = {
  markAsRead: 'MarkNotificationAsRead',
  billingNotification: 'ReceiveBillingNotification',
  invitationNotification: 'SendInvitationToUser',
  loadNotifications: 'ReceiveNotifications',
}

export default INVOKE_FUNCTIONS
